import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { KENYA, FEATURES } from '../constants';

/**
 * WhatsApp Floating Button Component
 * Shows a floating WhatsApp button for quick orders
 */
const WhatsAppButton = ({ productName, productUrl, className = '' }) => {
  if (!FEATURES.ENABLE_WHATSAPP_ORDER) {
    return null;
  }

  const handleWhatsAppClick = () => {
    const message = KENYA.WHATSAPP_MESSAGE_TEMPLATE
      .replace('{productName}', productName || 'this product')
      .replace('{productUrl}', productUrl || window.location.href);
    
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${KENYA.WHATSAPP_NUMBER}?text=${encodedMessage}`;
    
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className={`fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg transition-all duration-300 hover:scale-110 group ${className}`}
      aria-label="Order via WhatsApp"
      title="Quick Order via WhatsApp"
    >
      <FaWhatsapp className="w-7 h-7" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-1 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Order via WhatsApp
      </span>
      {/* Pulse animation */}
      <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-75"></span>
    </button>
  );
};

export default WhatsAppButton;
